<a
  [routerLink]="{ cxRoute: 'home' } | cxUrl"
  class="btn btn-send"
>
  {{ "cartDetails.continueShopping" | cxTranslate }}
</a>
